import React from "react";
import Grid from "@mui/material/Grid2";
import MobileStyles from "../MobileStyles";
import WebStyles from "../WebStyles";
import { Typography, TextField } from "@mui/material";
import { useSelector } from "react-redux";

const BeneficiaryIbanField = (props) => {
  const selector = useSelector((data) => data?.mobileReducer);
  const isMobile = selector?.ismobile;
  const classes = isMobile ? MobileStyles() : WebStyles();
  const {
    beneDetails,
    isEditable,
    flag,
    handleChange,
    handleBlurChange,
    review,
    disableFlag,
    checkErrors,
  } = props;

  return (
    <>
      <Grid size={{ xs: 12, md: 6 }} className={classes.spacing}>
        <Typography variant="body2" className={classes.headerstyle}>
        Beneficiary IBAN
        </Typography>
        {isEditable ? (
          <TextField
            variant="outlined"
            size="small"
            value={beneDetails?.CdtrAcctIdIBAN}
            onChange={handleChange}
            onBlur={handleBlurChange}
            error={Boolean(checkErrors("CdtrAcctIdIBAN"))}
            helperText={checkErrors("CdtrAcctIdIBAN")}
            name="CdtrAcctIdIBAN"
            disabled={disableFlag}
          />
        ) : (
          <span className={classes.contentstyle}>
            {review ? beneDetails?.MaskIBANNumb : beneDetails?.CdtrAcctIdIBAN}
          </span>
        )}

        {flag && beneDetails?.IsValidBeneNameURL && (
          <img
            src={beneDetails?.IsValidBeneNameURL}
            className={classes.checkMark}
          />
        )}
      </Grid>
    </>
  );
};

export default BeneficiaryIbanField;
